export const queryKeysShutdowns = {
  shutdowns: (url) => ['shutdowns', url],
  savedFilters: () => ['shutdowns', 'savedFilters'],
  defaultFilter: () => ['shutdowns', 'defaultFilter'],
};
